export default __webpack_public_path__ + "static/media/ic_branches.c1ac58e3.svg";